var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.addClass},[_c('i',{staticClass:"fas fa-credit-card"})])}
var staticRenderFns = []

export { render, staticRenderFns }